{
  "stripe_not_configured": "Les paiements Stripe ne sont pas encore configurés.",
  "stripe_not_ready": "Les abonnements ne sont pas encore ouverts. Aucun paiement n’a été effectué.",
  "stripe_error": "Stripe n’a pas pu traiter la demande. Réessaie ou contacte l’administration.",
  "premium_already_active": "Ton Premium est déjà actif. Utilise la gestion de ton abonnement.",
  "subscription_exists": "Un abonnement ou un paiement est déjà en cours. Ouvre sa gestion pour éviter une double facturation.",
  "premium_required": "Un Premium actif est nécessaire pour cette personnalisation.",
  "premium_changed": "Ton accès Premium a changé. Recharge ton profil avant de réessayer.",
  "premium_price_invalid": "Le tarif Stripe doit être actif, à 3,99 € par mois, taxes incluses le cas échéant.",
  "premium_product_unavailable": "Ce produit est introuvable avec la clé Stripe actuelle. Vérifie le compte et le mode test/réel : aucun produit de remplacement n’a été créé.",
  "premium_product_invalid": "Le produit Premium doit avoir un identifiant prod_, être actif et correspondre au mode de la clé Stripe.",
  "premium_product_mismatch": "Le tarif configuré n’appartient pas au produit Premium sélectionné.",
  "premium_product_price_missing": "Ajoute au produit existant un tarif fixe actif de 3,99 € par mois, taxes incluses le cas échéant.",
  "premium_product_price_ambiguous": "Plusieurs tarifs compatibles existent. Choisis un tarif par défaut ou définis STRIPE_PREMIUM_PRICE_ID.",
  "billing_portal_inactive": "Le portail Stripe ne permet pas encore la gestion complète de l’abonnement.",
  "billing_live_disabled": "Les paiements réels restent désactivés jusqu’à validation commerciale et fiscale.",
  "billing_url_invalid": "L’adresse du site n’est pas configurée pour les paiements.",
  "checkout_unavailable": "La page de paiement n’a pas pu être préparée.",
  "checkout_pending": "Une page de paiement ou une validation est déjà en cours. Réessaie dans un instant.",
  "checkout_expiring": "Une précédente préparation de paiement expire bientôt. Attends son expiration avant de réessayer.",
  "billing_customer_missing": "Ce compte n’a pas encore de dossier de facturation.",
  "billing_environment_mismatch": "L’administration doit clôturer les abonnements de l’autre environnement Stripe avant l’effacement.",
  "billing_invoice_too_large": "Cette facture doit être vérifiée dans Stripe.",
  "billing_risk_too_large": "Ce paiement doit être vérifié dans Stripe.",
  "billing_report_too_large": "Plus de 5 000 mouvements : choisis une période plus courte ou les rapports Stripe.",
  "billing_subscription_inactive": "Cet abonnement ne permet plus la gestion du renouvellement.",
  "billing_payment_not_refundable": "Ce paiement n’est pas encaissé dans cet environnement.",
  "billing_refund_amount": "Le montant dépasse le reste remboursable.",
  "billing_refund_verification_required": "Cette ancienne demande n’a pas de résultat enregistré. Vérifie les remboursements dans Stripe avant de retenter.",
  "premium_image_target": "Choisis une carte pour ce portrait, ou un avatar/une bannière sans carte.",
  "premium_upload_busy": "Une image est déjà en cours d’enregistrement. Réessaie dans un instant.",
  "premium_image_invalid": "Utilise un PNG, JPEG ou WebP statique de 15 Mo, 4 mégapixels et 4096 pixels par côté au maximum.",
  "premium_image_too_large": "Cette image dépasse 15 Mo. Réduis sa taille avant de l’importer.",
  "premium_image_limit": "La carte ou le compte a changé, ou la limite de 20 portraits est atteinte.",
  "friend_limit_changed": "La demande ou ta limite d’amis a changé. Recharge la page avant de réessayer.",
  "showcase_limit_changed": "Ta limite de vitrine a changé. Recharge ton profil avant de réessayer.",
  "automation_forbidden": "Les bots, agents IA et auto-clickers sont interdits sur ANIDEX. Joue depuis ton navigateur ou l’application.",
  "network_error": "Impossible de joindre ANIDEX. Vérifie ta connexion.",
  "http_error": "Erreur {{status}}.",
  "unexpected": "Une erreur inattendue est survenue.",
  "payload_too_large": "Requête trop volumineuse.",
  "not_found": "Route introuvable.",
  "internal_error": "Une erreur interne est survenue.",
  "upgrade_required": "Connexion WebSocket requise.",
  "unauthorized": "Connecte-toi pour continuer.",
  "validation_error": "Certaines informations sont invalides.",
  "invalid_json": "Le corps de la requête n’est pas un JSON valide.",
  "invalid_id": "Identifiant invalide.",
  "invalid_cursor": "Cette page d’historique n’est plus valide. Actualise l’historique.",
  "history_unavailable": "Impossible de lire cet historique. Réessaie ou vérifie les journaux du serveur.",
  "already_claimed": "Tu as déjà réclamé cette récompense.",
  "quest_character_required": "Choisis la carte qui reçoit les fragments.",
  "card_not_owned": "Tu ne possèdes pas cette carte.",
  "ip_taken": "Un compte existe déjà depuis cette adresse.",
  "ip_banned": "Cette adresse est bannie.",
  "account_busy": "Une enchère vient de changer. Réessaie.",
  "wrong_password": "Mot de passe incorrect.",
  "banner_unavailable": "Cette œuvre ne peut pas servir de bannière.",
  "day_missing": "Le calendrier du mois est introuvable.",
  "quest_not_completed": "Cette quête n’est pas encore terminée.",
  "rarity_unavailable": "Aucun personnage de cette rareté n’est disponible pour le moment.",
  "email_taken": "Cette adresse email est déjà utilisée.",
  "username_taken": "Ce pseudo est déjà pris.",
  "turnstile_failed": "La vérification anti-robot a échoué. Réessaie.",
  "human_check_required": "Confirme que tu es humain pour continuer à jouer.",
  "account_blocked": "Ce compte est bloqué.",
  "invalid_token": "Ce lien de vérification est invalide ou a expiré.",
  "already_verified": "Ton adresse email est déjà vérifiée.",
  "card_locked": "Cette carte est verrouillée (vente, enchère ou échange en cours).",
  "already_listed": "Ce personnage a déjà une annonce active.",
  "listing_conflict": "Cette annonce vient d’être modifiée. Réessaie.",
  "listing_sold": "Cette annonce vient d’être vendue ou annulée.",
  "auction_conflict": "Cette enchère vient d’être modifiée. Réessaie.",
  "idempotency_key_reused": "Cette clé a déjà servi.",
  "trade_exists": "Un échange est déjà en cours avec ce joueur.",
  "trade_conflict": "Cet échange vient d’être modifié.",
  "stale_revision": "Cette proposition a été mise à jour. Recharge la page.",
  "cards_moved": "Une des cartes n’est plus disponible. Elle a été vendue ou déplacée.",
  "missing_idempotency_key": "L’en-tête Idempotency-Key est obligatoire.",
  "booster_unavailable": "Ce booster est indisponible.",
  "invalid_quantity": "Quantité de boosters non autorisée.",
  "concurrent_opening": "Une autre ouverture est en cours. Réessaie dans un instant.",
  "invalid_origin": "Origine de la requête non autorisée.",
  "no_session": "Session invalide.",
  "friend_requests_disabled": "Ce joueur n’accepte pas les demandes d’ami.",
  "already_friends": "Vous êtes déjà amis.",
  "already_pending": "Une demande est déjà en attente.",
  "cooldown": "Attends un peu avant de renvoyer une demande à ce joueur.",
  "friends_full": "Tu as atteint la limite d’amis.",
  "requests_full": "Tu as trop de demandes en attente.",
  "their_friends_full": "Ce joueur a atteint sa limite d’amis.",
  "invalid_target": "Action impossible.",
  "already_reported": "Tu as déjà signalé ce contenu.",
  "collection_private": "Cette collection est privée.",
  "compare_self": "Tu ne peux pas te comparer à toi-même.",
  "profile_private": "Ce profil est privé.",
  "invalid_duration": "Durée d’enchère invalide.",
  "too_many_auctions": "Tu as atteint le nombre maximum d’enchères actives.",
  "auction_not_active": "Cette enchère n’est plus active.",
  "has_bids": "Impossible d’annuler une enchère qui a déjà des mises.",
  "auction_ended": "Cette enchère est terminée.",
  "own_auction": "Tu ne peux pas enchérir sur ta propre annonce.",
  "already_highest": "Tu es déjà le meilleur enchérisseur.",
  "bid_too_low": "La mise est trop basse.",
  "use_buyout": "Utilise l’achat immédiat pour ce montant.",
  "no_buyout": "Cette enchère n’a pas de prix d’achat immédiat.",
  "max_level": "Cette carte a déjà atteint son niveau maximum.",
  "not_enough_fragments": "Tu n’as pas assez de fragments pour cette amélioration.",
  "upgrade_conflict": "Cette carte vient d’être modifiée. Recharge la page.",
  "card_feature_locked": "Cette personnalisation n’est pas encore débloquée au niveau de ta carte.",
  "card_customization_changed": "Cette carte a changé entre-temps. Recharge sa fiche avant de réessayer.",
  "fragment_conversion_changed": "Ces fragments ont changé entre-temps. Recharge la collection avant de réessayer.",
  "invalid_upgrade_cursor": "Ce curseur n’est valable que pour l’amélioration de toutes les cartes.",
  "market_level": "Le marché n’est pas encore disponible pour ton niveau.",
  "price_out_of_bounds": "Ce prix est hors des bornes autorisées pour ce personnage.",
  "empty_buyback": "Choisis au moins une carte.",
  "buyback_too_many": "Tu as sélectionné trop de cartes.",
  "favorite_protected": "Un favori ne peut pas être vendu au système.",
  "buyback_too_small": "Une carte ne vaut pas assez pour être reprise par le système.",
  "buyback_conflict": "Une carte vient de changer. Recharge la page.",
  "invalid_reaction": "Réaction invalide.",
  "invalid_peer": "Conversation invalide.",
  "not_friends": "La messagerie est réservée à tes amis.",
  "client_id_reused": "Cet identifiant client a déjà servi pour un autre message.",
  "invalid_character": "Personnage introuvable.",
  "empty_message": "Ajoute un message ou partage une carte.",
  "message_too_long": "Message trop long.",
  "invalid_sitemap": "Sitemap inconnu.",
  "referral_invalid": "Ce code de parrainage n’existe pas.",
  "referral_sponsor_unverified": "Ce parrain n’a pas encore vérifié son compte.",
  "referral_self": "Tu ne peux pas utiliser ton propre code.",
  "referral_cycle": "Ton filleul ne peut pas devenir ton parrain.",
  "referral_sponsor_newer": "Ton parrain doit être inscrit avant toi.",
  "referral_already_set": "Tu as déjà un parrain.",
  "referral_window_closed": "Un code de parrainage doit être saisi dans les {{days}} jours suivant l’inscription.",
  "retry": "Une collision rare est survenue. Réessaie."
}
